/* Soera's configured Favi blur/focus titles and attribution, without timer or jQuery dependencies. */
(function () {
  if (window.HFTA_SCRIPT_INJECTED !== undefined) return;
  window.HFTA_SCRIPT_INJECTED = true;

  function report(url) {
    // Match jQuery.getJSON's GET URL, Accept header and cross-origin credential policy.
    fetch(url, {
      headers: { Accept: 'application/json, text/javascript, */*; q=0.01' },
      credentials: 'same-origin'
    }).catch(function () {});
  }

  try {
    if (location.pathname.indexOf('thank_you') > -1 || location.pathname.indexOf('post_purchase') > -1) {
      try {
        if (localStorage.getItem('effectiveAppsHFTA_RTOP') === 'true') {
          report('https://hfta-app.herokuapp.com/rss/None/' + Shopify.checkout.total_price.toString());
          localStorage.removeItem('effectiveAppsHFTA_RTOP');
        }
      } catch (error) {}
      return;
    }
  } catch (error) {}

  window.effectiveAppsOriginalPageTitle = document.title;
  window.addEventListener('blur', function () {
    var secondTitle = false;
    document.title = '⚡ Selling fast—come back!';
    window.effectiveAppsHocusFocusInterval = setInterval(function () {
      secondTitle = !secondTitle;
      document.title = secondTitle ? '🛍️ Your picks are waiting' : '⚡ Selling fast—come back!';
    }, 1500);
  });

  window.addEventListener('focus', function () {
    try { report('https://hfta-app.herokuapp.com/rus/None'); } catch (error) {}
    localStorage.setItem('effectiveAppsHFTA_RTOP', 'true');
    window.typeWriterEnabled = false;
    clearInterval(window.effectiveAppsHocusFocusInterval);
    document.title = window.effectiveAppsOriginalPageTitle;
  });
})();
